import type { PropsWithChildren } from 'react';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { useLayoutStore } from '~/features/layout-base-page/store.ts';

import { Header } from './components/header.tsx';
import { Sidebar } from './components/sidebar.tsx';
import styles from './layout-base-page.module.css';

export function LayoutBasePage({ children }: PropsWithChildren) {
  const sidebarCollapsed = useLayoutStore().sidebarCollapsed;
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div
      className={twMerge([
        'bg-navigation-bg',
        styles['layout'],
        sidebarCollapsed && styles['collapsed'],
      ])}
      style={{ '--sidebar-width': sidebarCollapsed ? '78px' : '240px' } as React.CSSProperties}
    >
      <Header className={twMerge(styles['header'], 'lg:hidden')} openMenu={() => { setMenuOpen(true); }} />
      <div className={styles['sidebar']}>
        <Sidebar
          isOpen={menuOpen}
          close={() => { setMenuOpen(false); }}
        />
      </div>
      <div
        className={twMerge(
          'overflow-y-auto bg-primary-contrast',
          'lg:m-2 lg:ml-0 lg:rounded-xl lg:shadow-sm',
          styles['main'],
        )}
        data-scroll-area-viewport="base-layout"
      >
        <main className="@container p-4">
          {children}
        </main>
      </div>
    </div>
  );
}
